var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInformationCommunication(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9783 12.6226L27.9783 16.373",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9753 8.07007C27.7871 8.07007 27.6345 7.91615 27.6345 7.72632C27.6345 7.53646 27.7871 7.38257 27.9753 7.38257",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9812 8.07007C28.1694 8.07007 28.3221 7.91615 28.3221 7.72632C28.3221 7.53646 28.1694 7.38257 27.9812 7.38257",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.10596 36.1245H36.1262",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.21973 19.5295C6.21973 20.9437 6.78152 22.3 7.78151 23.3C8.7815 24.3 10.1378 24.8618 11.552 24.8618C12.9662 24.8618 14.3225 24.3 15.3224 23.3C16.3224 22.3 16.8842 20.9437 16.8842 19.5295C16.8842 18.1153 16.3224 16.759 15.3224 15.759C14.3225 14.7591 12.9662 14.1973 11.552 14.1973C10.1378 14.1973 8.7815 14.7591 7.78151 15.759C6.78152 16.759 6.21973 18.1153 6.21973 19.5295Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.10229 36.1282V33.3122C3.10229 28.646 6.88495 24.8633 11.5511 24.8633C16.2173 24.8633 19.9999 28.646 19.9999 33.3122V36.1282",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0823 19.2187C22.8448 20.9453 25.2584 22.0099 27.9207 22.0099C33.318 22.0099 37.6932 17.6345 37.6932 12.2372C37.6932 6.83995 33.318 2.4646 27.9207 2.4646C22.6868 2.4646 18.4139 6.57903 18.1599 11.7499",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationCommunication);
export default __webpack_public_path__ + "static/media/InformationCommunication.fbd6450330bbc6b86f5fcf7b46fe2319.svg";
export { ForwardRef as ReactComponent };